import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { read, voting } from '../../services/vote';
import swal from 'sweetalert';
import { Col, Row } from 'react-bootstrap';
import { showUserDetail } from '../../redux/slicers/userSlice';
import moment from 'moment';

const Vote = (props) => {
    const id = props.id;

    const auth = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [data, setDate] = useState(null);

    useEffect(() => {
        async function getDetail(id){
            const res = await read(auth.token, id);
            if(res.error == null){
                setDate(res.data);
            }else{
                swal("Gagal", res.error, "error");

                navigate('/');
            }
        }

        getDetail(id);
    }, [auth]);

    const viewDetail = (id) => {
        dispatch(showUserDetail(id));
    }

    const votingUser = async (user) => {
        //show confirm
        var confirm = await swal({
            title: "Konfirmasi",
            text: "Apakah anda yakin ingin memilih " + (user.first_name + ' '+ user.last_name) + " sebagai pemenang?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });

        if(confirm){
            const res = await voting(auth.token, id, user.id);
            if(res.error === null){
                swal("Berhasil", "Pemenang telah dipilih", "success");

                navigate('/');
            }else{
                swal("Gagal", res.error, "error");
            }
        }
    }

    return (
        <div>
            {
                data != null ? (
                    <div className='text-center'>
                        <h4>{ data.name }</h4>
                        <div className='box p-3'>
                            <div>
                                <b>Waktu <i>Voting</i>:</b>
                            </div>
                            {
                                moment(data.start_datetime).format('HH:mm, DD MMMM YYYY') + ' - ' + moment(data.end_datetime).format('HH:mm, DD MMMM YYYY')
                            }
                        </div>
                        <div className='box p-3 mt-3'>
                            <p style={{
                                fontWeight: 'bold'
                            }}>{ data.description }</p>
                            <div className='mb-5' dangerouslySetInnerHTML={{ __html: data.body }} />
                        </div>

                        <Row>
                        {
                            data.candidates.map((candidate, index) => (
                                <Col key={index}>
                                    <div className='text-center box p-3 mt-3'>
                                        <div>
                                            <img src={ candidate.avatar } alt={ candidate.first_name } className='mb-3' style={{
                                                width: '100px',
                                                height: '100px',
                                                borderRadius: '50%'
                                            }} />
                                        </div>
                                        <div style={{
                                            cursor: 'pointer',
                                        }} onClick={() => viewDetail(candidate.user_id)}>
                                            { candidate.first_name+' '+candidate.last_name }
                                        </div>
                                        <div>
                                            <button onClick={() => votingUser(candidate)} className='btn btn-sm btn-default mt-3'>Pilih</button>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                        </Row>
                    </div>
                ) : null
            }
        </div>
    );
}

export default Vote;